import { AttachInternals, Component, Element, h, Host, Prop, State } from '@stencil/core'

/**
 * ## Design System
 *
 * Para a documentação completa de design, incluindo diretrizes de uso, acessibilidade e exemplos visuais, consulte o [Design System do GovBR](https://www.gov.br/ds/components/menu-info?tab=designer).
 *
 * @slot default - Slot para conteúdo personalizado no lugar do texto padrão de informações.
 */
@Component({
  tag: 'br-menu-info',
  styleUrl: 'menu-info.scss',
  shadow: true,
  formAssociated: true,
})
export class MenuInfo {
  /**
   * Referência ao elemento host do componente.
   * Utilize esta propriedade para acessar e manipular o elemento do DOM associado ao componente.
   */
  @Element() el: HTMLBrMenuInfoElement

  @AttachInternals() elementInternals: ElementInternals

  /**
   * Identificador único.
   * Caso não seja fornecido, um ID gerado automaticamente será usado.
   */
  @Prop({ reflect: true }) readonly customId: string = `br-menu-info-${MenuInfoId++}`

  /**
   * Informações adicionais em formato de texto
   */
  @Prop({ reflect: true }) info?: string

  // Estado para verificar se há conteúdo no slot default
  @State() hasSlotContent: boolean = false

  componentWillLoad() {
    this.hasSlotContent = this.el.innerHTML.trim() !== ''
  }

  render() {
    return (
      <Host>
        <slot>{!this.hasSlotContent && this.info && <div class="text-center text-down-01">{this.info}</div>}</slot>
      </Host>
    )
  }
}

let MenuInfoId = 0
